import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

const navLinks = [
  { label: "首页", to: "/" },
  { label: "最新更新", to: "/latest" },
  { label: "人气榜单", to: "/ranking" },
  { label: "漫画分类", to: "/#genres" },
  { label: "关于我们", to: "/about" },
];

export default function MangaNavbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [keyword, setKeyword] = useState("");
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  const isHome = location.pathname === "/";
  const solid = scrolled || !isHome;

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    const q = keyword.trim();
    navigate(q ? `/latest?q=${encodeURIComponent(q)}` : "/latest");
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        solid ? "bg-background-50/90 backdrop-blur-md shadow-sm border-b border-background-200" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <nav className="flex items-center justify-between h-16 md:h-[72px]" aria-label="主导航">
          <Link to="/" className="flex items-center gap-2 group shrink-0">
            <span className="w-10 h-10 rounded-xl bg-primary-500 text-background-50 flex items-center justify-center shadow-soft group-hover:bg-primary-600 transition-colors">
              <i className="ri-book-open-fill text-xl"></i>
            </span>
            <span className="font-heading text-xl md:text-2xl text-foreground-950">
              天天<span className="text-primary-500">漫画</span>网
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {navLinks.map((link) => {
              const active = link.to === "/" ? location.pathname === "/" : location.pathname.startsWith(link.to);
              return (
                <Link
                  key={link.label}
                  to={link.to}
                  className={`px-4 py-2 rounded-full text-sm whitespace-nowrap transition-colors ${
                    active
                      ? "text-primary-700 bg-primary-100 font-medium"
                      : solid
                        ? "text-foreground-700 hover:text-primary-600 hover:bg-primary-50"
                        : "text-background-100 hover:text-white hover:bg-white/10"
                  }`}
                >
                  {link.label}
                </Link>
              );
            })}
          </div>

          <div className="hidden lg:flex items-center gap-3">
            <form onSubmit={handleSearch} className="relative">
              <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400 text-sm"></i>
              <input
                type="text"
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                placeholder="搜索漫画名称"
                className="w-44 h-10 rounded-full bg-background-100 border border-background-200 pl-9 pr-3 text-sm text-foreground-900 outline-none focus:border-primary-300 focus:ring-2 focus:ring-primary-200/60 placeholder:text-foreground-400 transition-all"
                aria-label="搜索漫画"
              />
            </form>
            <Link
              to="/latest"
              className="h-10 px-5 rounded-full bg-primary-500 text-background-50 text-sm font-medium flex items-center gap-1.5 whitespace-nowrap hover:bg-primary-600 transition-colors"
            >
              <i className="ri-notification-3-line"></i>开始追更
            </Link>
          </div>

          <button
            type="button"
            onClick={() => setMenuOpen((v) => !v)}
            className="md:hidden w-10 h-10 rounded-lg bg-background-100 flex items-center justify-center text-foreground-800 cursor-pointer"
            aria-label="打开菜单"
            aria-expanded={menuOpen}
          >
            <i className={menuOpen ? "ri-close-line text-xl" : "ri-menu-line text-xl"}></i>
          </button>
        </nav>
      </div>

      {menuOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200 px-4 py-4">
          <div className="flex flex-col gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.label}
                to={link.to}
                className="px-3 py-2.5 rounded-lg text-foreground-800 hover:bg-primary-50 hover:text-primary-700"
              >
                {link.label}
              </Link>
            ))}
            <form onSubmit={handleSearch} className="relative mt-2">
              <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400 text-sm"></i>
              <input
                type="text"
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                placeholder="搜索漫画名称"
                className="w-full h-11 rounded-lg bg-background-100 border border-background-200 pl-9 pr-3 text-sm text-foreground-900 outline-none focus:border-primary-300 placeholder:text-foreground-400"
              />
            </form>
          </div>
        </div>
      )}
    </header>
  );
}